import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getCouponCampuses } from '../api/coupons.api';
import { ICouponCampus, IGetCouponCampuses } from '../models/coupons.model';

interface ICouponCampusState {
  couponCampuses: ICouponCampus[];
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: ICouponCampusState = {
  couponCampuses: [],
  isLoading: false
};

const couponCampusSlicer = createSlice({
  name: 'couponCampus',
  initialState,
  reducers: {
    getCouponCampusesStart: (state: ICouponCampusState) => {
      state.couponCampuses = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getCouponCampusesSuccess: (state: ICouponCampusState, action: PayloadAction<IGetCouponCampuses>) => {
      state.couponCampuses = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getCouponCampusesFailure: (state: ICouponCampusState, action: PayloadAction<AxiosError|string>) => {
      state.couponCampuses = [];
      state.isLoading = false;
      state.error = action.payload;
    },
  }
});

export const {
  getCouponCampusesStart,
  getCouponCampusesSuccess,
  getCouponCampusesFailure,
} = couponCampusSlicer.actions;

export default couponCampusSlicer.reducer;

export const doGetCouponCampuses = (couponCode: number): any => async (dispatch: any) => {
  try {
    dispatch(getCouponCampusesStart());
    const response = await getCouponCampuses(couponCode);
    dispatch(getCouponCampusesSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getCouponCampusesFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
